import { jsx } from "react/jsx-runtime";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { validateTidalLicense } from "../../base/index.js";
function QuestionMark(props) {
  return /* @__PURE__ */ jsx(
    QuestionMarkIcon,
    {
      "data-testid": "QuestionMark",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "QuestionMark",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
QuestionMark.tidalIconMeta = {
  categories: "cancel,informative",
  name: "QuestionMark"
};
validateTidalLicense();
export {
  QuestionMark
};
//# sourceMappingURL=QuestionMark.js.map
